const extractTagComment = (rawTag: string) => {
  const parts = rawTag.split(':')
  return {
    id: parts[1],
    nickname: parts[2].slice(0, -1),
  }
}

export const PROFILE_PATH_REG = /\/profile\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/
export const TAG_MARKDOWN_REG = /\[@[^\]]+\]\(\/profile\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gu

export const parseContentToMarkdown = (content: string): string => {
  const urlReg = /[(http(s)?):/(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi
  const tagReg = /\[@:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}:[^\]]+\]/gu

  const matchs = [...(content.match(urlReg) || []), ...(content.match(tagReg) || [])]

  let formattedContent = content

  matchs.forEach((m) => {
    let content = ''

    if (m.match(urlReg)) {
      let url = m.replace(/\.+$/, '')

      if (!/(http(s)?):\/\//.test(url)) {
        url = `http://${m}`
      }

      content = `[${m}](${url})`
    } else if (m.match(tagReg)) {
      const comment = extractTagComment(m)
      content = `[@${comment.nickname}](/profile/${comment.id})`
    }

    formattedContent = formattedContent.replaceAll(m, content)
  })

  formattedContent = formattedContent.replace(/\n/gi, '&nbsp; \n')

  return formattedContent || ''
}
